/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { CustomerCancellationReason$inboundSchema, CustomerCancellationReason$outboundSchema, } from "./customercancellationreason.js";
import { DiscountFixedOnceForeverDurationBase$inboundSchema, DiscountFixedOnceForeverDurationBase$outboundSchema, } from "./discountfixedonceforeverdurationbase.js";
import { DiscountFixedRepeatDurationBase$inboundSchema, DiscountFixedRepeatDurationBase$outboundSchema, } from "./discountfixedrepeatdurationbase.js";
import { DiscountPercentageOnceForeverDurationBase$inboundSchema, DiscountPercentageOnceForeverDurationBase$outboundSchema, } from "./discountpercentageonceforeverdurationbase.js";
import { DiscountPercentageRepeatDurationBase$inboundSchema, DiscountPercentageRepeatDurationBase$outboundSchema, } from "./discountpercentagerepeatdurationbase.js";
import { LegacyRecurringProductPrice$inboundSchema, LegacyRecurringProductPrice$outboundSchema, } from "./legacyrecurringproductprice.js";
import { Product$inboundSchema, Product$outboundSchema, } from "./product.js";
import { ProductPrice$inboundSchema, ProductPrice$outboundSchema, } from "./productprice.js";
import { SubscriptionCustomer$inboundSchema, SubscriptionCustomer$outboundSchema, } from "./subscriptioncustomer.js";
import { SubscriptionMeter$inboundSchema, SubscriptionMeter$outboundSchema, } from "./subscriptionmeter.js";
import { SubscriptionRecurringInterval$inboundSchema, SubscriptionRecurringInterval$outboundSchema, } from "./subscriptionrecurringinterval.js";
import { SubscriptionStatus$inboundSchema, SubscriptionStatus$outboundSchema, } from "./subscriptionstatus.js";
/** @internal */
export const Metadata$inboundSchema = z.union([z.string(), z.int(), z.number(), z.boolean()]);
/** @internal */
export const Metadata$outboundSchema = z.union([z.string(), z.int(), z.number(), z.boolean()]);
export function metadataToJSON(metadata) {
    return JSON.stringify(Metadata$outboundSchema.parse(metadata));
}
export function metadataFromJSON(jsonString) {
    return safeParse(jsonString, (x) => Metadata$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Metadata' from JSON`);
}
/** @internal */
export const CustomFieldData$inboundSchema = z.union([
    z.string(),
    z.int(),
    z.boolean(),
    z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
]);
/** @internal */
export const CustomFieldData$outboundSchema = z.union([
    z.string(),
    z.int(),
    z.boolean(),
    z.pipe(z.date(), z.transform(v => v.toISOString())),
]);
export function customFieldDataToJSON(customFieldData) {
    return JSON.stringify(CustomFieldData$outboundSchema.parse(customFieldData));
}
export function customFieldDataFromJSON(jsonString) {
    return safeParse(jsonString, (x) => CustomFieldData$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CustomFieldData' from JSON`);
}
/** @internal */
export const SubscriptionDiscount$inboundSchema = z.union([
    DiscountFixedRepeatDurationBase$inboundSchema,
    DiscountFixedOnceForeverDurationBase$inboundSchema,
    DiscountPercentageRepeatDurationBase$inboundSchema,
    DiscountPercentageOnceForeverDurationBase$inboundSchema,
]);
/** @internal */
export const SubscriptionDiscount$outboundSchema = z.union([
    DiscountFixedRepeatDurationBase$outboundSchema,
    DiscountFixedOnceForeverDurationBase$outboundSchema,
    DiscountPercentageRepeatDurationBase$outboundSchema,
    DiscountPercentageOnceForeverDurationBase$outboundSchema,
]);
export function subscriptionDiscountToJSON(subscriptionDiscount) {
    return JSON.stringify(SubscriptionDiscount$outboundSchema.parse(subscriptionDiscount));
}
export function subscriptionDiscountFromJSON(jsonString) {
    return safeParse(jsonString, (x) => SubscriptionDiscount$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SubscriptionDiscount' from JSON`);
}
/** @internal */
export const SubscriptionPrices$inboundSchema = z.union([
    LegacyRecurringProductPrice$inboundSchema,
    ProductPrice$inboundSchema,
]);
/** @internal */
export const SubscriptionPrices$outboundSchema = z.union([
    LegacyRecurringProductPrice$outboundSchema,
    ProductPrice$outboundSchema,
]);
export function subscriptionPricesToJSON(subscriptionPrices) {
    return JSON.stringify(SubscriptionPrices$outboundSchema.parse(subscriptionPrices));
}
export function subscriptionPricesFromJSON(jsonString) {
    return safeParse(jsonString, (x) => SubscriptionPrices$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SubscriptionPrices' from JSON`);
}
/** @internal */
export const Subscription$inboundSchema = z.pipe(z.object({
    created_at: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    modified_at: z.nullable(z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v)))),
    id: z.string(),
    amount: z.int(),
    currency: z.string(),
    recurring_interval: SubscriptionRecurringInterval$inboundSchema,
    recurring_interval_count: z.int(),
    status: SubscriptionStatus$inboundSchema,
    current_period_start: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    current_period_end: z.nullable(z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v)))),
    trial_start: z.nullable(z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v)))),
    trial_end: z.nullable(z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v)))),
    cancel_at_period_end: z.boolean(),
    canceled_at: z.nullable(z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v)))),
    started_at: z.nullable(z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v)))),
    ends_at: z.nullable(z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v)))),
    ended_at: z.nullable(z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v)))),
    customer_id: z.string(),
    product_id: z.string(),
    discount_id: z.nullable(z.string()),
    checkout_id: z.nullable(z.string()),
    seats: z.optional(z.nullable(z.int())),
    customer_cancellation_reason: z.nullable(CustomerCancellationReason$inboundSchema),
    customer_cancellation_comment: z.nullable(z.string()),
    metadata: z.record(z.string(), z.union([z.string(), z.int(), z.number(), z.boolean()])),
    custom_field_data: z.optional(z.record(z.string(), z.nullable(z.union([
        z.string(),
        z.int(),
        z.boolean(),
        z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ])))),
    customer: SubscriptionCustomer$inboundSchema,
    product: Product$inboundSchema,
    discount: z.nullable(z.union([
        DiscountFixedRepeatDurationBase$inboundSchema,
        DiscountFixedOnceForeverDurationBase$inboundSchema,
        DiscountPercentageRepeatDurationBase$inboundSchema,
        DiscountPercentageOnceForeverDurationBase$inboundSchema,
    ])),
    prices: z.array(z.union([
        LegacyRecurringProductPrice$inboundSchema,
        ProductPrice$inboundSchema,
    ])),
    meters: z.array(SubscriptionMeter$inboundSchema),
}), z.transform((v) => {
    return remap$(v, {
        "created_at": "createdAt",
        "modified_at": "modifiedAt",
        "recurring_interval": "recurringInterval",
        "recurring_interval_count": "recurringIntervalCount",
        "current_period_start": "currentPeriodStart",
        "current_period_end": "currentPeriodEnd",
        "trial_start": "trialStart",
        "trial_end": "trialEnd",
        "cancel_at_period_end": "cancelAtPeriodEnd",
        "canceled_at": "canceledAt",
        "started_at": "startedAt",
        "ends_at": "endsAt",
        "ended_at": "endedAt",
        "customer_id": "customerId",
        "product_id": "productId",
        "discount_id": "discountId",
        "checkout_id": "checkoutId",
        "customer_cancellation_reason": "customerCancellationReason",
        "customer_cancellation_comment": "customerCancellationComment",
        "custom_field_data": "customFieldData",
    });
}));
/** @internal */
export const Subscription$outboundSchema = z.pipe(z.object({
    createdAt: z.pipe(z.date(), z.transform(v => v.toISOString())),
    modifiedAt: z.nullable(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    id: z.string(),
    amount: z.int(),
    currency: z.string(),
    recurringInterval: SubscriptionRecurringInterval$outboundSchema,
    recurringIntervalCount: z.int(),
    status: SubscriptionStatus$outboundSchema,
    currentPeriodStart: z.pipe(z.date(), z.transform(v => v.toISOString())),
    currentPeriodEnd: z.nullable(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    trialStart: z.nullable(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    trialEnd: z.nullable(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    cancelAtPeriodEnd: z.boolean(),
    canceledAt: z.nullable(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    startedAt: z.nullable(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    endsAt: z.nullable(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    endedAt: z.nullable(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    customerId: z.string(),
    productId: z.string(),
    discountId: z.nullable(z.string()),
    checkoutId: z.nullable(z.string()),
    seats: z.optional(z.nullable(z.int())),
    customerCancellationReason: z.nullable(CustomerCancellationReason$outboundSchema),
    customerCancellationComment: z.nullable(z.string()),
    metadata: z.record(z.string(), z.union([z.string(), z.int(), z.number(), z.boolean()])),
    customFieldData: z.optional(z.record(z.string(), z.nullable(z.union([
        z.string(),
        z.int(),
        z.boolean(),
        z.pipe(z.date(), z.transform(v => v.toISOString())),
    ])))),
    customer: SubscriptionCustomer$outboundSchema,
    product: Product$outboundSchema,
    discount: z.nullable(z.union([
        DiscountFixedRepeatDurationBase$outboundSchema,
        DiscountFixedOnceForeverDurationBase$outboundSchema,
        DiscountPercentageRepeatDurationBase$outboundSchema,
        DiscountPercentageOnceForeverDurationBase$outboundSchema,
    ])),
    prices: z.array(z.union([
        LegacyRecurringProductPrice$outboundSchema,
        ProductPrice$outboundSchema,
    ])),
    meters: z.array(SubscriptionMeter$outboundSchema),
}), z.transform((v) => {
    return remap$(v, {
        createdAt: "created_at",
        modifiedAt: "modified_at",
        recurringInterval: "recurring_interval",
        recurringIntervalCount: "recurring_interval_count",
        currentPeriodStart: "current_period_start",
        currentPeriodEnd: "current_period_end",
        trialStart: "trial_start",
        trialEnd: "trial_end",
        cancelAtPeriodEnd: "cancel_at_period_end",
        canceledAt: "canceled_at",
        startedAt: "started_at",
        endsAt: "ends_at",
        endedAt: "ended_at",
        customerId: "customer_id",
        productId: "product_id",
        discountId: "discount_id",
        checkoutId: "checkout_id",
        customerCancellationReason: "customer_cancellation_reason",
        customerCancellationComment: "customer_cancellation_comment",
        customFieldData: "custom_field_data",
    });
}));
export function subscriptionToJSON(subscription) {
    return JSON.stringify(Subscription$outboundSchema.parse(subscription));
}
export function subscriptionFromJSON(jsonString) {
    return safeParse(jsonString, (x) => Subscription$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Subscription' from JSON`);
}
//# sourceMappingURL=subscription.js.map